import React, {CSSProperties} from 'react';
import {Tooltip} from './styledComponents';
import {Button, SvgIcon, SxProps} from '@mui/material';
import {SvgIconColor} from "../lib/interfaces";
import {Theme} from "@mui/material/styles";

type StyleKey = 'root' | 'hoverColor' | 'light' | 'miniButton' | 'icon';
type Styles = {
    [K in StyleKey]?: SxProps
    // hoverColor? : (props: { hoverColor: string }) => CSSProperties;
}

const styles: Styles = {
    root: {
        pointerEvents: "all",
        cursor: "pointer !important",
        minWidth: "initial !important",
        borderRadius: "200px  !important",
    },
    hoverColor: (props: RoundButtonProps) => ({
        "&:hover": {
            backgroundColor: props.hoverColor
        }
    }),
    light: {
        color: "#ffffff",
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
    },
    miniButton: {
        width: "30px",
        height: "30px",
    },
    icon: {
        pointerEvents: "none",
    },
};


export type RoundButtonProps = {
    icon?: typeof SvgIcon;
    variant?: string,
    color?: SvgIconColor,
    forwardedRef?: any,
    light?: boolean,
    label?: string,
    labelPlacement?: string,
    labelEnterDelay?: number,
    onMouseDown?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    children?: any,
    propagate?: boolean,
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    width?: number,
    sx?: SxProps,
    style?: CSSProperties,
    hoverColor?: string,
    disabled?: boolean,
}

const RoundButton = (
        {
            icon: Icon,
            variant,
            color,
            light,
            label,
            labelPlacement = "bottom",
            labelEnterDelay = 200,
            onMouseDown,
            children,
            propagate,
            onClick,
            width,
            sx = {},
            style = {},
            hoverColor,
            disabled,
        }: RoundButtonProps) => {

    const iconStyle: SxProps<Theme> = {};

    if (width) {
        style["width"] = width + "px !important";

        style.height = width + "px !important";
        // @ts-ignore
        iconStyle["fontSize"] = width * 0.7 + "px !important";
    }

    if (disabled) {
        style["opacity"] = "0.4"
    }

    const rootStyle: SxProps = {
        ...styles.root,
        ...sx,
        ...!width && variant === "mini" && styles.miniButton,
        ...light && styles.light,
        //@todo this works?
        ...hoverColor && styles.hoverColor,
    };

    return <Tooltip
            title={label}
            placement={labelPlacement}
            enterDelay={labelEnterDelay}
    >
      <span
              style={{
                  cursor: "pointer",
              }}
      >
          <Button
                  sx={{
                      padding: "0 !important",
                      width: "40px !important",
                      height: "40px !important",
                      ...style,
                      ...rootStyle,
                  }}
                  onClick={(event) => {
                      if (onClick && !disabled) {
                          onClick(event);
                      }
                  }}
                  onMouseDown={event => {
                      if (onMouseDown) {
                          onMouseDown(event)
                      }
                      if (!propagate) {
                          event.stopPropagation();
                      }

                  }}
          >
              {Icon && <Icon
                      sx={{
                          ...styles.icon,
                      }}
                      color={color}
              />}
              {children}
    </Button>
      </span>

    </Tooltip>
};

export default React.forwardRef<any, RoundButtonProps>((props, ref) =>
        <RoundButton {...props} forwardedRef={ref}/>
);
